import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {ScoreboardWidgetState} from "./models/scoreboard-widget.state";
import {ScoreboardWidgetConfig} from "./scoreboard-widget.config";

export class ScoreboardWidgetStore extends BaseMobxStore {
  static injectables = [ScoreboardWidgetConfig, ScoreboardWidgetState];
}

